import './style.scss';
import $ from 'jquery';
import jQueryBridget from 'jquery-bridget';
import gsap from 'gsap';
import { Draggable } from "gsap/Draggable";
import { ScrollTrigger } from "gsap/ScrollTrigger.js";
import imagesloaded from 'imagesloaded';

jQueryBridget( 'imagesloaded', imagesloaded, $ );

gsap.registerPlugin(Draggable);
gsap.registerPlugin(ScrollTrigger);

function heroSliderFunction() {
  if($(".wp-block-thefuturblocks-hero-slider").length > 0) {
    $(".wp-block-thefuturblocks-hero-slider").each(function() {
      var self = $(this),
        slides = self.find(".wp-block-thefuturblocks-hero-slide"),
        overlays = self.find(".wp-block-thefuturblocks-hero-slide__image"),
        imgs = self.find(".wp-block-thefuturblocks-hero-slide__image img"),
        titles = self.find(".wp-block-thefuturblocks-hero-slide__inner"),
        widthTitle = self.find(".wp-block-thefuturblocks-hero-slide__title").width(),
        maskTitles = self.find(".wp-block-thefuturblocks-hero-slide__mask-title"),
        masks = self.find(".wp-block-thefuturblocks-hero-slide__mask"),
        masksWidth = masks.width(),
        dots = self.find(".wp-block-thefuturblocks-hero-slider__dots"),
        wrapper = self.find(".wp-block-thefuturblocks-hero-slider__wrapper"),
        activeDotColor = dots.attr("data-active"),
        dotColor = dots.attr("data-dot"),
        dotBorderColor = dots.attr("data-bor-color"),
        dotActiveBorderColor = dots.attr("data-bor-acolor"),
        highestSlide = 0,
        moveSlideTL = gsap.timeline();

      let maskPos = -masksWidth/2,
          nextLoop;

      function dotClick() {
        if(!moveSlideTL.isActive()) {
          var slideFrom = self.find(".wp-block-thefuturblocks-hero-slide.active"),
            	overlayFrom = slideFrom.find(".wp-block-thefuturblocks-hero-slide__image"),
            	imgFrom = slideFrom.find(".wp-block-thefuturblocks-hero-slide__image img"),
              titleFrom = slideFrom.find(".wp-block-thefuturblocks-hero-slide__inner"),
              maskTitleFrom = slideFrom.find(".wp-block-thefuturblocks-hero-slide__mask-title"),
              maskFrom = slideFrom.find(".wp-block-thefuturblocks-hero-slide__mask"),
              sectionToIndex = $(this).index(),
              slideTo = slides.eq(sectionToIndex),
              overlayTo = overlays.eq(sectionToIndex),
              imgTo = imgs.eq(sectionToIndex),
              titleTo = titles.eq(sectionToIndex),
              maskTitleTo = maskTitles.eq(sectionToIndex),
              maskTo = masks.eq(sectionToIndex);

          if(slideFrom.index() !== slideTo.index() && slideFrom.index() < slideTo.index()) {
            moveToSlide(slideFrom, slideTo, overlayFrom, overlayTo, imgFrom, imgTo, titleTo, titleFrom, maskTitleTo, maskTitleFrom, maskTo, maskFrom);
          }
          if(slideFrom.index() !== slideTo.index() && slideFrom.index() > slideTo.index()) {
            moveFromSlide(slideFrom, slideTo, overlayFrom, overlayTo, imgFrom, imgTo, titleTo, titleFrom, maskTitleTo, maskTitleFrom, maskTo, maskFrom);
          }
          
          if (self.hasClass("has-autoplay")) {
            // Stop the last one
              nextLoop.kill();
              // Start it again
              looper();
          }
        }
      }

      function nextClick() {
        if(!moveSlideTL.isActive()) {
          var slideFrom = self.find(".wp-block-thefuturblocks-hero-slide.active"),
              overlayFrom = slideFrom.find(".wp-block-thefuturblocks-hero-slide__image"),
              imgFrom = slideFrom.find(".wp-block-thefuturblocks-hero-slide__image img"),
              titleFrom = slideFrom.find(".wp-block-thefuturblocks-hero-slide__inner"),
              maskTitleFrom = slideFrom.find(".wp-block-thefuturblocks-hero-slide__mask-title"),
              maskFrom = slideFrom.find(".wp-block-thefuturblocks-hero-slide__mask"),
              sectionToIndex = slides.index(slideFrom);

          if(sectionToIndex !== slides.length - 1) {
            var slideTo = slides.eq(sectionToIndex + 1),
                overlayTo = overlays.eq(sectionToIndex + 1),
                imgTo = imgs.eq(sectionToIndex + 1),
                titleTo = titles.eq(sectionToIndex + 1),
                maskTitleTo = maskTitles.eq(sectionToIndex + 1),
                maskTo = masks.eq(sectionToIndex + 1);
            moveToSlide(slideFrom, slideTo, overlayFrom, overlayTo, imgFrom, imgTo, titleTo, titleFrom, maskTitleTo, maskTitleFrom, maskTo, maskFrom);
          } else {
            slideTo = slides.eq(0);
            overlayTo = overlays.eq(0);
            imgTo = imgs.eq(0);
            titleTo = titles.eq(0);
            maskTitleTo = maskTitles.eq(0);
            maskTo = masks.eq(0);
            moveToSlide(slideFrom, slideTo, overlayFrom, overlayTo, imgFrom, imgTo, titleTo, titleFrom, maskTitleTo, maskTitleFrom, maskTo, maskFrom);
          }
          if (self.hasClass("has-autoplay")) {
            // Stop the last one
              nextLoop.kill();
              // Start it again
              looper();
          }
        }
      }

      function prevClick() {
        if(!moveSlideTL.isActive()) {
          var slideFrom = self.find(".wp-block-thefuturblocks-hero-slide.active"),
              overlayFrom = slideFrom.find(".wp-block-thefuturblocks-hero-slide__image"),
              imgFrom = slideFrom.find(".wp-block-thefuturblocks-hero-slide__image img"),
              titleFrom = slideFrom.find(".wp-block-thefuturblocks-hero-slide__inner"),
              maskTitleFrom = slideFrom.find(".wp-block-thefuturblocks-hero-slide__mask-title"),
              maskFrom = slideFrom.find(".wp-block-thefuturblocks-hero-slide__mask"),
              sectionToIndex = slides.index(slideFrom);
          
          if(sectionToIndex !== 0) {
            var slideTo = slides.eq(sectionToIndex - 1),
                overlayTo = overlays.eq(sectionToIndex - 1),
                imgTo = imgs.eq(sectionToIndex - 1),
                titleTo = titles.eq(sectionToIndex - 1),
                maskTitleTo = maskTitles.eq(sectionToIndex - 1),
                maskTo = masks.eq(sectionToIndex - 1);
            moveFromSlide(slideFrom, slideTo, overlayFrom, overlayTo, imgFrom, imgTo, titleTo, titleFrom, maskTitleTo, maskTitleFrom, maskTo, maskFrom);
          } else {
            slideTo = slides.eq(slides.length - 1);
            overlayTo = overlays.eq(slides.length - 1);
            imgTo = imgs.eq(slides.length - 1);
            titleTo = titles.eq(slides.length - 1);
            maskTitleTo = maskTitles.eq(slides.length - 1);
            maskTo = masks.eq(slides.length - 1);
            moveFromSlide(slideFrom, slideTo, overlayFrom, overlayTo, imgFrom, imgTo, titleTo, titleFrom, maskTitleTo, maskTitleFrom, maskTo, maskFrom);
          }
          if (self.hasClass("has-autoplay")) {
            // Stop the last one
              nextLoop.kill();
              // Start it again
              looper();
          }
        }
      }

      function moveToSlide(slideFrom, slideTo, overlayFrom, overlayTo, imgFrom, imgTo, titleTo, titleFrom, maskTitleTo, maskTitleFrom, maskTo, maskFrom) {

            moveSlideTL = gsap.timeline({onStart: setActiveSlide, onStartParams: [slideTo]})
            .to(imgFrom, {duration:0.6,xPercent:100})
            .to(overlayFrom, {duration:0.6,xPercent:-100}, "<")
            // .to(titleFrom, {duration: 4, xPercent:-100}, "<")
            .to(titleFrom, {duration: 0.6, autoAlpha:0, skewY:5, y:40, force3D:false}, "<")
            // .to(maskTitleFrom, {duration: 4, xPercent:-200,y:-masksWidth}, "<")
            .to(maskTitleFrom, {duration: 0.6, autoAlpha:0, skewY:5, xPercent:-100,y:-masksWidth+40, force3D:false}, "<")
            .to(maskFrom, {duration: 0.6, xPercent:100,yPercent:100}, "<")
            .set(slideFrom, {clearProps:"all",className: "wp-block-thefuturblocks-hero-slide"})

            .set(slideTo, {autoAlpha:1, className: "wp-block-thefuturblocks-hero-slide active"}, "<")
            .fromTo(overlayTo, {xPercent:100}, {duration:0.6,xPercent:0}, "<")
            .fromTo(imgTo, {xPercent:-100}, {duration:0.6,xPercent:0}, "<")
            // .fromTo(titleTo, {xPercent:-100},
            //  {duration: 0.6, xPercent:0,force3D:false}, "<")
            .fromTo(titleTo, {autoAlpha:0, skewY:5, y:40},
             {duration: 0.6, autoAlpha:1, skewY:0, y:0,force3D:false}, "<")
            // .fromTo(maskTitleTo, {xPercent:0,y:masksWidth},
            //  {duration: 0.6, xPercent:0,y:0, x:maskPos,force3D:false}, "<")
            .fromTo(maskTitleTo, {xPercent:100,autoAlpha:0, skewY:5, y:masksWidth + 40},
             {duration: 0.6, autoAlpha:1, xPercent:0,skewY:0, y:0, x:maskPos,force3D:false}, "<")
            .fromTo(maskTo, {xPercent:-100,yPercent:-100},
             {duration: 0.6, xPercent:0,yPercent:0}, "<")
      }

      function moveFromSlide(slideFrom, slideTo, overlayFrom, overlayTo, imgFrom, imgTo, titleTo, titleFrom, maskTitleTo, maskTitleFrom, maskTo, maskFrom) {

            moveSlideTL = gsap.timeline({onStart: setActiveSlide, onStartParams: [slideTo]})
            .to(imgFrom, {duration:0.6,xPercent:-100})
            .to(overlayFrom, {duration:0.6,xPercent:100}, "<")
            // .to(titleFrom, {duration: 0.6, xPercent:-100}, "<")
            .to(titleFrom, {duration: 0.6, autoAlpha:0, skewY:5, y:40, force3D:false}, "<")
            // .to(maskTitleFrom, {duration: 4, xPercent:0,y:masksWidth}, "<")
            .to(maskTitleFrom, {duration: 0.6, xPercent:100, autoAlpha:0, skewY:5, y:masksWidth+40, force3D:false}, "<")
            .to(maskFrom, {duration: 0.6, xPercent:-100,yPercent:-100}, "<")
            .set(slideFrom, {clearProps:"all",className: "wp-block-thefuturblocks-hero-slide"})

            .set(slideTo, {autoAlpha:1, className: "wp-block-thefuturblocks-hero-slide active"}, "<")
            .fromTo(overlayTo, {xPercent:-100}, {duration:0.6,xPercent:0}, "<")
            .fromTo(imgTo, {xPercent:100}, {duration:0.6,xPercent:0}, "<")
            // .fromTo(titleTo, {xPercent:-100},
            //  {duration: 4, xPercent:0,force3D:false, clearProps:"all"}, "<")
            .fromTo(titleTo, {autoAlpha:0, skewY:5, y:40},
             {duration: 0.6, autoAlpha:1, skewY:0, y:0,force3D:false}, "<")
            // .fromTo(maskTitleTo, {xPercent:-200,y:-masksWidth},
            //  {duration: 4, xPercent:0,y:0, x:maskPos,force3D:false}, "<")
            .fromTo(maskTitleTo, {xPercent:-100,autoAlpha:0, skewY:5, y:-masksWidth + 40},
             {duration: 0.6, autoAlpha:1, xPercent:0,skewY:0, y:0, x:maskPos,force3D:false}, "<")
            .fromTo(maskTo, {xPercent:100,yPercent:100},
             {duration: 0.6, xPercent:0,yPercent:0}, "<")
      }

      function setActiveSlide(slideTo) {
        var currentSlideIndex = slides.index(slideTo),
          activeDot = self.find(".wp-block-thefuturblocks-hero-slider__dot.active"),
          activeDotInner = activeDot.find(".wp-block-thefuturblocks-hero-slider__dot-inner"),
          defDot = self.find(".wp-block-thefuturblocks-hero-slider__dot").eq(currentSlideIndex),
          defDotInner = defDot.find(".wp-block-thefuturblocks-hero-slider__dot-inner");
        gsap.to(activeDot, {duration:0.6,className: "wp-block-thefuturblocks-hero-slider__dot"});
        gsap.to(activeDotInner, {duration:0.6,backgroundColor:dotColor,borderColor:dotBorderColor});
        gsap.to(defDot, {duration:0.6,className: "wp-block-thefuturblocks-hero-slider__dot active"});
        gsap.to(defDotInner, {duration:0.6,backgroundColor:activeDotColor,borderColor:dotActiveBorderColor});

      }

      if(self.hasClass("is-draggable")) {
        var proxy = $('<div></div>');
        Draggable.create(proxy, {
          trigger: self,
          type: "x",
          cursor: "grab",
          activeCursor: "grabbing",
          onDrag: function() {
            if(this.deltaX > 10) {
              prevClick();
            }
            if(this.deltaX < -10) {
              nextClick();
            }
          }
        });
      }

      function looper() {
        var autoplayTimer = self.data("autoplay");
        nextLoop = gsap.delayedCall(autoplayTimer, function() {
          nextClick();
        });
      }

      if (self.hasClass("has-autoplay")) {
        looper();
      }

      function init() {
        for( var i = 0; i < slides.length; i++ ) {
          var dot = $('<div></div>').addClass("wp-block-thefuturblocks-hero-slider__dot").appendTo(dots);
          var dotInner = $('<div></div>').addClass("wp-block-thefuturblocks-hero-slider__dot-inner").appendTo(dot);
        }
        self.find(".wp-block-thefuturblocks-hero-slider__dot:first-child").addClass("active");
        var dotClicked = self.find(".wp-block-thefuturblocks-hero-slider__dot");
        var dotClickedInner = dotClicked.find(".wp-block-thefuturblocks-hero-slider__dot-inner");
        gsap.set(dotClickedInner, {backgroundColor: dotColor});
        dotClicked.on('click', dotClick);

        // next.on('click', nextClick);
        // prev.on('click', prevClick);

        var activeSlide = self.find(".wp-block-thefuturblocks-hero-slide:first"),
          slidesWrapper = self.find(".wp-block-thefuturblocks-hero-slider__wrapper");

        var activeDot = self.find(".wp-block-thefuturblocks-hero-slider__dot.active"),
            activeDotInner = activeDot.find(".wp-block-thefuturblocks-hero-slider__dot-inner"),
            defDot = self.find(".wp-block-thefuturblocks-hero-slider__dot"),
            defDotInner = defDot.find(".wp-block-thefuturblocks-hero-slider__dot-inner");

          gsap.set(defDotInner, {backgroundColor:dotColor, borderColor:dotBorderColor});
          gsap.set(activeDotInner, {backgroundColor:activeDotColor, borderColor:dotActiveBorderColor});

        gsap.set(activeSlide, {autoAlpha:1, className: "wp-block-thefuturblocks-hero-slide active"});
        gsap.set(maskTitles, {width:widthTitle, x:maskPos});

      }

      init();

      slides.imagesloaded(() => {
        slides.each(function(){
          var maskTitle = $(this).find(".wp-block-thefuturblocks-hero-slide__mask-title"),
              inner = $(this).find(".wp-block-thefuturblocks-hero-slide__inner"),
              btnHeight = inner.find(".wp-block-thefuturblocks-button").outerHeight(),
              subHeight = inner.find(".wp-block-thefuturblocks-hero-slide__subtitle").outerHeight();

          let marBotHeight = 40 + btnHeight,
              marTopHeight = 8 + subHeight;
          

          if ( inner.children(".wp-block-thefuturblocks-button").length ) {
              gsap.set(maskTitle, {paddingBottom:marBotHeight});
          }
          if ( inner.children(".wp-block-thefuturblocks-hero-slide__subtitle").length ) {
              gsap.set(maskTitle, {paddingTop:marTopHeight});
          }

          // if($(this).outerHeight() > highestSlide) {
          //   highestSlide = $(this).outerHeight();
          // }
          // gsap.set($(this), {height:highestSlide});
        })
      })
      
      $(window).resize(function() {
        var widthTitle = self.find(".wp-block-thefuturblocks-hero-slide__title").width(),
        masksWidth = self.find(".wp-block-thefuturblocks-hero-slide__mask").width(),
        maskTitles = self.find(".wp-block-thefuturblocks-hero-slide__mask-title");
        gsap.set(maskTitles, {width:widthTitle, x:maskPos});
      })

    })
  }
}

function heroActiveReveal() {
  if($(".wp-block-thefuturblocks-hero-slide.active").length) {
    var slide = $(".wp-block-thefuturblocks-hero-slide.active"),
        loader = $('.c-loader'),
        overlay = slide.find(".wp-block-thefuturblocks-hero-slide__image"),
        img = slide.find(".wp-block-thefuturblocks-hero-slide__image img"),
        title = slide.find(".wp-block-thefuturblocks-hero-slide__inner"),
        maskTitle = slide.find(".wp-block-thefuturblocks-hero-slide__mask-title"),
        mask = slide.find(".wp-block-thefuturblocks-hero-slide__mask"),
        maskWidth = mask.width(),
        maskPos = -maskWidth/2,
        dots = $('.wp-block-thefuturblocks-hero-slider__dot'),
        tl = gsap.timeline({paused:true});

        tl.fromTo(overlay, {xPercent:100}, {duration:0.6,xPercent:0})
        .fromTo(img, {xPercent:-100}, {duration:0.6,xPercent:0}, "<")
        // .fromTo(title, {xPercent:-100},
        //  {duration: 0.6, xPercent:0,force3D:false}, "<")
        .fromTo(title, {autoAlpha:0, skewY:5, y:40},
         {duration: 0.6, autoAlpha:1, skewY:0, y:0,force3D:false}, "<")
        // .fromTo(maskTitle, {xPercent:0,y:maskWidth},
        //  {duration: 0.6, xPercent:0,y:0, x:maskPos,force3D:false}, "<")
        .fromTo(maskTitle, {xPercent:100,autoAlpha:0, skewY:5, y:maskWidth + 40},
         {duration: 0.6, autoAlpha:1, xPercent:0,skewY:0, y:0, x:maskPos,force3D:false}, "<")
        .fromTo(mask, {xPercent:-100,yPercent:-100},
         {duration: 0.6, xPercent:0,yPercent:0}, "<")
        .fromTo(dots, {autoAlpha:0,y:40},
         {duration: 0.2, autoAlpha:1,y:0, stagger:0.2}, "<");

        loader.length ? tl.play().delay(4) : tl.play().delay(0.4);
  }
}

function heroImageFunction() {
  if($(".wp-block-thefuturblocks-hero-slide__image").length) {
    $(".wp-block-thefuturblocks-hero-slide__image").each(function() {
      const self = $(this),
        image = self.find("img"),
        tl = gsap.to(image, {duration: 1, yPercent:-16.6, ease:"none"});
      const st = ScrollTrigger.create({
        trigger: self,
        start: 'top +=200',
        end: 'bottom +=200',
        scrub: 0.5,
          toggleActions: "play reverse play reverse",
        animation: tl,
      });
        
    });
  }
}

$(window).on('load', () => {
  heroSliderFunction();
  heroActiveReveal();
  heroImageFunction();
});